import { Box } from "@mui/material";
import EventCalendar from "../../features/events/Calendar/EventCalendar";
export default function Home() {
  return (
    <Box sx={{ flex: 1, position: "relative", pt: 3 }}>{<EventCalendar />}</Box>
  );
}
